import { mutator } from 'satcheljs';
import { getDiagnosticsLogState } from '../store/store';
import {
    logServiceRequestDiagnostics,
    registerServiceRequestDiagnostics,
    selectServiceDiagnosticsItem,
} from '../actions/serviceRequestDiagnostics';
import { DiagnosticsLogger, ServiceRequestDataPoint } from '../store/schema/DiagnosticsLogState';

const MAX_DATAPOINT_LENGTH = 200;
const LOGGER_NAME = 'Service Request';

mutator(logServiceRequestDiagnostics, msg => {
    const logger = getDiagnosticsLogState().loggers.get(LOGGER_NAME);
    logger.datapoints.unshift(msg.datapoint);

    if (logger.datapoints.length > MAX_DATAPOINT_LENGTH) {
        logger.datapoints.pop();
    }
});

mutator(registerServiceRequestDiagnostics, () => {
    getDiagnosticsLogState().loggers.set(LOGGER_NAME, <DiagnosticsLogger<ServiceRequestDataPoint>>{
        datapoints: [],
        type: 'ServiceRequest',
        selected: null,
    });
});

mutator(selectServiceDiagnosticsItem, msg => {
    const logger = getDiagnosticsLogState().loggers.get(LOGGER_NAME);
    const filtered = logger.datapoints.filter(dp => dp.requestId == msg.key);
    logger.selected = filtered.length > 0 ? filtered[0] : null;
});
